module.exports = __webpack_public_path__ + "img/vodafone.8e798235.png";